<template>
  <gl-page icon-name="gr-search" title="Error, page not found">
    <div class="contentNotFound">
      <p class="contentNotFound__text">
        Sorry, but it seems like the page you were trying to view does not exist.
      </p>
    </div>
  </gl-page>
</template>

<script>
import GlPage from '@gl/GlPage'

export default {
  name: 'NotFound',
  components: { GlPage },
}
</script>

<style lang="scss" scoped>
::v-deep(.pageContent__title) {
  text-transform: none;
}

.contentNotFound {
  &__text {
    color: rgba(255, 255, 255, 0.3);
    font-size: 14px;
    line-height: 24px;
  }
}
</style>
